import {
  Component,
  EnvironmentInjector,
  Input,
  ViewChild,
  ViewContainerRef,
  OnInit,
  AfterViewInit,
  Output,
  EventEmitter,
  input,
  model,
} from '@angular/core';
import { ELabelType, FormItem, IComponent } from '../../types';
import { LabelComponent } from '../label/label.component';
import { components, LoadingService } from '..';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-section',
  standalone: true,
  imports: [LabelComponent, CommonModule],
  templateUrl: './section.component.html',
  styleUrl: './section.component.css',
})
export class SectionComponent implements AfterViewInit {
  name = input.required<string>();
  filters = input.required<IComponent[]>();
  inList = input<boolean>(true);
  withBorder = input<boolean>(true);
  @ViewChild('container', { read: ViewContainerRef })
  container?: ViewContainerRef;
  formSignalsSection? = model<FormItem[]>();

  ELabelType = ELabelType;

  constructor(
    private envInjector: EnvironmentInjector,
    private loadingService: LoadingService
  ) {}

  ngAfterViewInit(): void {
    this.renderComponents();
  }

  renderComponents() {
    for (let i = 0; i < this.filters().length; i++) {
      const form = this.filters()[i];

      const component = this.container?.createComponent(
        (components as any)[form.component],
        {
          environmentInjector: this.envInjector,
        }
      );
      if (!component) {
        this.loadingService.stop();
        return;
      }
      const itemDTO = new FormItem();
      itemDTO.component = component;
      itemDTO.selector = form.selector;
      (itemDTO.inputs as any) = {};
      component.setInput('editable', form.inputs.editable ?? true);
      component.setInput('value', '');
      (itemDTO.inputs as any)['value'] = (component.instance as any)[
        'value'
      ];
      for (const input of Object.keys(form.inputs)) {
        component.setInput(input, (form.inputs as any)[input]);
        (itemDTO.inputs as any)[input] = (component.instance as any)[
          input
        ];
      }
      this.formSignalsSection?.update((value) => [...(value ?? []), itemDTO]);
    }
  }
}
